module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ib4OYr/tc-custom/9783968650012.jpg?1703128476944",
      "alt": "This image is the cover for the book The Man Who Hated Mars and eleven more Stories Vol I, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Man Who Hated Mars and eleven more Stories Vol I, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Twelve Classic Short Stories from The Golden Age of Science Fiction by Randall Garrett, Volume 1. Featured here: \"The Man Who Hated Mars\", \"Special Delivery\", \"His Master's Voice\", \"Thin Edge\", \"A World by the Tale\", \"The Penal Cluster\", \"The Unnecessary Man\", \"Fifty Per Cent Prophet\", \"Suite Mentale\", \"Viewpoint\", \"What The Left Hand Was Doing\", and \"The Foreign Hand Tie\".")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Randall Garrett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Randall Garrett (December 16, 1927 – December 31, 1987) was an American science fiction and fantasy author. He was a contributor to Astounding and other science fiction magazines of the 1950s and 1960s. He instructed Robert Silverberg in the techniques of selling large quantities of action-adventure science fiction, and collaborated with him on two novels about men from Earth disrupting a peaceful agrarian civilization on an alien planet.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0